import { FC } from "react";
import { BrandIcon } from "@components/icons";
import "./auth-layout.scss";
import { Navigate, Outlet } from "react-router-dom";
import useUser from "@hooks/use-user";
import { Loader } from "@components/loader";
import { useFavicon } from "@hooks/use-favicon";

const AuthLayout: FC = () => {
  const { user, loading } = useUser();

  useFavicon("./logo.png");

  if (loading) {
    return <Loader />;
  }

  if (user) {
    return <Navigate to="/apps" />;
  }

  return (
    <div className="login-container">
      <div className="login-wrapper">
        <div className="content-container">
          <div className="logo">
            <BrandIcon color="#ffffff" size={50} /> <h1>Unifylist</h1>
          </div>
          <div className="content-wrap">
            <h1>Welcome to UNIFYLIST</h1>
            <h2>Elevate your efficiency</h2>
            <p>
              UNIFYLIST let your account streamline task, automate workflow and boost productivity.
              Experience the efficiency of SaaS program as you simplify complexity and achieve
              success
            </p>
            <h2>Join us and revolutionize how we work</h2>
          </div>
        </div>
        <div className="form-container">
          <div className="form-content">
            <span className="logo-mobile">
              <BrandIcon size={30} />
              <h2>Unifylist</h2>
            </span>
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
